import React, { FormEvent, useState } from 'react';

import { LoadingButton } from '@atlaskit/button';
import Textfield from '@atlaskit/textfield';

import { InputSearchIcon } from '../../atoms/InputSearchIcon';
import { ContainerStyled, TextSearchStyled } from './FolderSearch.styled';

type Props = {
  onSearch: (value: string) => void;
  isLoading?: boolean;
};

export function FolderSearch({
  onSearch,
  isLoading = false,
}: Props): JSX.Element {
  const [currentValue, setCurrentValue] = useState('');
  const [isCurrentValueChanged, setIsCurrentValueChanged] = useState(false);

  const handleSearch = () => {
    onSearch(currentValue);
    setIsCurrentValueChanged(false);
  };

  const onTextSearchChange = (e: FormEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;

    if (value !== currentValue || !isCurrentValueChanged) {
      setCurrentValue(value);
      setIsCurrentValueChanged(true);
    }
  };

  return (
    <ContainerStyled>
      <TextSearchStyled>
        <Textfield
          value={currentValue}
          placeholder='Search for folder'
          testId='search-text-field'
          onChange={onTextSearchChange}
          elemBeforeInput={<InputSearchIcon />}
        />
      </TextSearchStyled>

      <LoadingButton
        onClick={handleSearch}
        appearance='primary'
        style={{ height: '100%', width: '72px', padding: '4px' }}
        isLoading={isLoading}
        isDisabled={!isCurrentValueChanged}
      >
        Search
      </LoadingButton>
    </ContainerStyled>
  );
}
